import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setLocaleAction } from "../../store/actions";
import { authLogoutAction } from '../../store/actions/auth';
import { Helmet } from "react-helmet";
import { FormattedMessage, injectIntl } from "react-intl";
import { NavLink, Link } from "react-router-dom";
import * as routerName from "../../utils/routerName";
import HasRole from "../../utils/entrust/HasRole";
import * as myAction from './../../store/actions';
import progressBar from '../../utils/progressBar';
import api from '../../utils/api';
import LogoutModal from './../../components/ConfirmModal/LogoutModal';
import {
    fetchCompaniesAction,
} from "./../../store/actions";
import { changeSceneCompanyAction, changeSceneLotAction } from "../../store/actions/sceneSelect";
import * as webSocketApi from "../../utils/websocketApi";
import {hasAuthToken} from "../../utils/authTokenStorage";

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.lastTrackedPath = null;
        this.state = {
            auth: [],
            visible: false,
            openModalLogout: false,
            dropdownOpen: false,
            companies: [],
            lots: [],
            company_id: localStorage.getItem("sel_company_id") ? localStorage.getItem("sel_company_id") : null,
            lots_id: localStorage.getItem("sel_lots_id") ? localStorage.getItem("sel_lots_id") : null,
            width: window.innerWidth,
            en_menu_1: localStorage.getItem("menu_1") === '1' ? true : false,
            en_menu_2: localStorage.getItem("menu_2") === '1' ? true : false,
            en_menu_3: localStorage.getItem("menu_3") === '1' ? true : false,
            en_menu_4: localStorage.getItem("menu_4") === '1' ? true : false,
        };
    }

    componentDidMount() {
        // paginate: get data Paginate Format  || list: get data List Format
        this.getCompanies();
        this.getSaleLots();
        this.trackMenuByPath(window.location.pathname);
        window.addEventListener('resize', this.handleWindowSizeChange);
    };

    componentDidUpdate() {
        const currentPath = window.location.pathname;
        if (this.lastTrackedPath !== currentPath) {
            this.trackMenuByPath(currentPath);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    };

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    trackMenuByPath = (menuPath) => {
        if (process.env.REACT_APP_ENABLE_MENU_TRACKING === 'false') {
            return;
        }

        if (!menuPath || !hasAuthToken()) {
            return;
        }

        if (!this.props.auth || !this.props.auth.user) {
            return;
        }

        if (this.lastTrackedPath === menuPath) {
            return;
        }

        this.lastTrackedPath = menuPath;
        const menuName = this.getMenuNameByPath(menuPath);
        setTimeout(() => {
            api.userLog.trackMenu({
                menu_path: menuPath,
                menu_name: menuName,
            }).catch(() => { });
        }, 0);
    };

    getMenuNameByPath = (menuPath) => {
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.USER_LOG}`)) {
            return '환경설정 - 사용자 로그 관리';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.CALL_HISTORY}`)) {
            return '환경설정 - 통화이력 조회';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.ITEM_MANAGEMENT}`)) {
            return '환경설정 - 상담항목 설정';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.TERRITORY_MANAGEMENT}`)) {
            return '환경설정 - 관리지역 설정';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.COUNSELOR_MANAGEMENT}`)) {
            return '환경설정 - 상담원 설정';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.LINE_INFORMATION}`)) {
            return '환경설정 - 회선 정보';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.COMPANY_REGISTRATION}`)) {
            return '환경설정 - 업체명 등록';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.AFFILITED_COMPANY_MANAGEMENT}`)) {
            return '환경설정 - 등록현장 관리';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}/${routerName.NOTICE}`)) {
            return '환경설정 - 공지사항';
        }
        if (menuPath.includes(`/${routerName.DATA_SETTING}`)) return '환경설정';

        if (menuPath === `/${routerName.DASHBOARD}` || menuPath === '/') return 'HOME';
        if (menuPath.includes(routerName.COMPANY_REGISTRATION)) return '회사등록';
        if (menuPath.includes(routerName.CUSTOMER_LIST)) return '고객 List';
        if (menuPath.includes(routerName.USER_REGISTRATION)) return '사용자등록';
        if (menuPath.includes(routerName.CUSTOMER_DATA)) return '고객 관리 - 고객 데이터';
        if (menuPath.includes(routerName.IVR_DATA)) return '고객 관리 - IVR 데이터';
        if (menuPath.includes(routerName.COUNSELLING_DATA)) return '고객 관리 - 상담 데이터';
        if (menuPath.includes(routerName.DAILY_REPORT)) return '통계 - 업무일지';
        if (menuPath.includes(routerName.ANALYSIS)) return '통계 - 상담분석';
        if (menuPath.includes(routerName.GRAPH)) return '통계 - 그래프';
        if (menuPath.includes(routerName.TELEPHONE)) return '전화상담';
        if (menuPath.includes(routerName.CUSTOMER_MANAGEMENT)) return '고객 관리';
        if (menuPath.includes(routerName.STATISTICS)) return '통계';
        if (menuPath.includes(routerName.SMS_TEXT_MANAGEMENT)) return '문자관리 - 문자관리';
        if (menuPath.includes(routerName.SMS_HISTORY_V2)) return '문자관리 - 발송이력';
        if (menuPath.includes(routerName.PREDEFINE_SMS)) return '문자관리 - 상담내용 문자 발송';
        if (menuPath.includes(routerName.REJECT_LIST)) return '문자관리 - 무료 수신거부 리스트';
        if (menuPath.includes(routerName.SMS_BULK_SENDING)) return '문자관리 - 대량발송';
        if (menuPath.includes(routerName.SMS_AUTO_SEND)) return '문자관리 - 자동 예약 문자';
        if (menuPath.includes(routerName.SMS_SETTING)) return '문자관리';
        if (menuPath.includes(routerName.FREE_BOARD)) return '게시판 - 자유게시판';
        if (menuPath.includes(routerName.REQ_BOARD)) return '게시판 - 건의게시판';
        if (menuPath.includes(routerName.BOARD)) return '게시판';
        return menuPath;
    };

    getCompanies = () => {
        progressBar.start();
        api.company.getCompanies({}).then(response => {

            response?.data?.data?.forEach((item) => {
                if (localStorage.getItem("sel_company_id") && localStorage.getItem("sel_company_id") === String(item.company_id)) {
                    this.props.changeSceneCompany(item.company_id);
                    this.setState({
                        company_id: item.company_id,
                    });
                }
            });

            this.setState({
                ...this.state,
                companies: response.data.data
            })
            progressBar.done();
        }).catch(error => {
            progressBar.done();
        });
    }

    getSaleLots = () => {
        progressBar.start();
        api.textManager.getSaleLotsOfUser().then(res => {

            res?.data?.data?.forEach((item) => {
                if (localStorage.getItem("sel_lots_id") && localStorage.getItem("sel_lots_id") === String(item.lots_id)) {
                    this.props.changeSceneLot(item.lots_id);
                    this.setState({
                        lots_id: item.lots_id,
                    });
                }
            });

            this.setState({
                lots: res.data.data
            })
            progressBar.done();
        }).catch(e => {
            progressBar.done();
        })
    }


    toggleMenu = () => {
        this.setState({ visible: !this.state.visible });
    };

    userLogoutHandle = () => {
        webSocketApi.closeWebsocket()
        this.props.onUserLogout();
    };

    selectLanguageHandle = (event) => {
        this.props.onSetLocale(event.target.value);
    };

    toggleModalLogout = () => {
        this.setState({
            openModalLogout: !this.state.openModalLogout,
        }, () => {
            //console.log(this.state, 'statee');
        });
    };

    toggleDropDown = () => {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen,
        }));
    };

    selectCompanyHandler = (event) => {
        let { value } = event.target;
        if (value) {
            const companyId = parseInt(value, 10);
            this.props.changeSceneCompany(companyId);
            this.setState({
                company_id: companyId,
            }, () => {
                localStorage.setItem('sel_company_id', String(companyId));
            });
        } else {
            this.props.changeSceneCompany(null);
            this.setState({
                company_id: null,
            }, () => {
                localStorage.setItem('sel_company_id', '');
                //console.log(this.state, 'set_state');
            });
        }
    };

    selectLotHandler = e => {
        let { value } = e.target;
        if (value) {
            const lotsId = parseInt(value, 10);
            this.props.changeSceneLot(lotsId);
            this.setState({
                lots_id: lotsId,
            }, () => {
                localStorage.setItem('sel_lots_id', String(lotsId));
            });
        } else {
            this.props.changeSceneLot(null);
            this.setState({
                lots_id: null,
            }, () => {
                localStorage.setItem('sel_lots_id', '');
            });
        }
    };



    render() {

        //console.log('localStorage',localStorage);
        //console.log('localStorage.menu_1',localStorage.menu_1);
        //console.log('localStorage.getItem',localStorage.getItem("menu_1"));
        //console.log('this.state.en_menu_1',this.state.en_menu_1);
        //				this.setState({
        //						...this.state,
        //						en_menu_1 : localStorage.getItem("menu_1") === '1' ? true : false,
        //						en_menu_2 : localStorage.getItem("menu_2") === '1' ? true : false,
        //						en_menu_3 : localStorage.getItem("menu_3") === '1' ? true : false,
        //						en_menu_4 : localStorage.getItem("menu_4") === '1' ? true : false
        //				});

        // 가로폭을 체크하여 모바일 on/off 처리 한다.
        const { width, company_id, lots_id } = this.state;
        const isMobile = width <= 500;

        const { appState } = this.props;
        const { companies, lots, en_menu_1, en_menu_2, en_menu_3, en_menu_4 } = this.state;
        const { pathname } = window.location;
        const arrPath = pathname.split('/');
        const segment2nd = arrPath[2];

        return (
            <Fragment>
                <FormattedMessage id="dashboard.dashboard" defaultMessage="Dashboard">
                    {(message) => (
                        <Helmet>
                            <title>{message}</title>
                        </Helmet>
                    )}
                </FormattedMessage>

                <header className="main_header">
                    <div className="box_menu_repo">
                        <span className="push_togle_menu">
                            <i className="fas fa-bars" />
                        </span>
                    </div>
                    <div className="container-fluid">
                        <div className="control_header">
                            <div className="float_left">
                                <HasRole role={['primarynet']}>
                                    <div className="select_version">
                                        <div className="control_select">
                                            <span className="txt_select">
                                                <FormattedMessage
                                                    id="dashboard.CompanyLabel"
                                                    defaultMessage="Company" />
                                            </span>
                                            <div className="box_control_input">
                                                <div className="box_select_input">
                                                    {/* selectbox list company */}
                                                    <select className="form_control" onChange={this.selectCompanyHandler} name="sltCompany" value={company_id || ''}>
                                                        <option value=''>
                                                            {this.props.intl.formatMessage({ id: 'dashboard.SelectCompany', defaultMessage: 'SelectCompany' })}
                                                        </option>
                                                        {
                                                            companies?.map((item, index) => (
                                                                <option key={index} value={item.company_id}>{item.company_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <span className="drop_down" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </HasRole>
                                <HasRole role={['admin']}>
                                    <div className="select_version">
                                        <div className="control_select">
                                            <span className="txt_select">
                                                <FormattedMessage
                                                    id="dashboard.scene"
                                                    defaultMessage="Scene" />
                                            </span>
                                            <div className="box_control_input">
                                                <div className="box_select_input">
                                                    {/* selectbox list company */}
                                                    <select className="form_control" onChange={this.selectLotHandler} name="sltLot" value={lots_id || ''}>
                                                        <option value=''>
                                                            {this.props.intl.formatMessage({ id: 'dashboard.SelectLot', defaultMessage: 'Select Lot' })}
                                                        </option>
                                                        {
                                                            lots?.map((item, index) => (
                                                                <option key={index} value={item.lots_id}>{item.lots_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <span className="drop_down" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </HasRole>
                                <HasRole role={['manager', 'telephone', 'visiting']}>
                                    <div className="select_version">
                                        <div className="control_select">
                                            <span className="txt_select">
                                                <FormattedMessage
                                                    id="dashboard.scene"
                                                    defaultMessage="Scene" />
                                            </span>
                                            <div className="box_control_input">
                                                <div className="box_select_input">
                                                    {/* selectbox list company */}
                                                    <select className="form_control" onChange={this.selectLotHandler} name="sltLot" value={lots_id || ''}>
                                                        {
                                                            lots?.map((item, index) => (
                                                                <option key={index} value={item.lots_id}>{item.lots_name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <span className="drop_down" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </HasRole>
                                <nav className="main_menu">
                                    <ul>
                                        <li>
                                            <NavLink to={`/${routerName.DASHBOARD}`}
                                                exact
                                                activeClassName="active">
                                                <FormattedMessage
                                                    id="dashboard.Home"
                                                    defaultMessage="Home" />
                                            </NavLink>
                                        </li>

                                        <HasRole role={['primarynet']}>
                                            <li>
                                                <NavLink to={`/${routerName.DASHBOARD}/${routerName.USER_REGISTRATION}`}
                                                    exact
                                                    activeClassName="active">
                                                    <FormattedMessage
                                                        id="dashboard.UserRegistration"
                                                        defaultMessage="User Registration" />
                                                </NavLink>
                                            </li>
                                        </HasRole>

                                        <HasRole role={['primarynet']}>
                                            <li>
                                                <NavLink to={`/${routerName.DASHBOARD}/${routerName.CUSTOMER_LIST}`}
                                                    exact
                                                    activeClassName="active">
                                                    <FormattedMessage
                                                        id="dashboard.CustomerList"
                                                        defaultMessage="Customer List" />
                                                </NavLink>
                                            </li>
                                        </HasRole>

                                        <HasRole role={['primarynet', 'admin', 'manager', 'telephone', 'visiting']}>
                                            <li>
                                                <NavLink to={`/${routerName.DASHBOARD}/${routerName.TELEPHONE}`}
                                                    exact
                                                    activeClassName="active">
                                                    <FormattedMessage
                                                        id="dashboard.TelephoneCounselling"
                                                        defaultMessage="Telephone Counselling" />
                                                </NavLink>
                                            </li>
                                        </HasRole>

                                        <HasRole role={['primarynet', 'admin', 'manager', 'telephone']}> {/*'primarynet', 'admin'*/}
                                            {localStorage.getItem("menu_2") === '1' ?
                                                <li>
                                                    <NavLink to={`/${routerName.DASHBOARD}/${routerName.CUSTOMER_MANAGEMENT}/${routerName.COUNSELLING_DATA}`}
                                                        exact
                                                        className={segment2nd == 'customer-management' ? 'active' : 'no_active'}
                                                        activeClassName="active">
                                                        <FormattedMessage
                                                            id="dashboard.CustomerManagement"
                                                            defaultMessage="Customer Management" />
                                                    </NavLink>
                                                </li>
                                                : ''
                                            }
                                        </HasRole>

                                        <HasRole role={['primarynet', 'admin', 'manager', 'telephone']}>{/*'primarynet', 'admin', 'manager'*/}
                                            {localStorage.getItem("menu_1") === '1' ?
                                                <li>
                                                    <NavLink to={`/${routerName.DASHBOARD}/${routerName.STATISTICS}/${routerName.DAILY_REPORT}`}
                                                        exact
                                                        className={segment2nd == 'statistics' ? 'active' : 'no_active'}
                                                        activeClassName="active">
                                                        <FormattedMessage
                                                            id="dashboard.Statistics"
                                                            defaultMessage="Statistics" />
                                                    </NavLink>
                                                </li>
                                                : ''
                                            }
                                        </HasRole>

                                        <HasRole role={['primarynet']}>
                                            <li>
                                                <NavLink to={`/${routerName.DASHBOARD}/${routerName.DATA_SETTING}/${routerName.COMPANY_REGISTRATION}`}
                                                    exact
                                                    className={segment2nd == 'data-setting' ? 'active' : 'no_active'}
                                                    activeClassName="active">
                                                    <FormattedMessage
                                                        id="dashboard.DataSetting"
                                                        defaultMessage="Data Setting" />
                                                </NavLink>
                                            </li>
                                        </HasRole>

                                        <HasRole role={['primarynet', 'admin', 'manager', 'telephone']}>{/*'admin'*/}
                                            {localStorage.getItem("menu_3") === '1' ?
                                                <li>
                                                    <NavLink to={`/${routerName.DASHBOARD}/${routerName.SMS_SETTING}/${routerName.SMS_MMS}/${routerName.SMS_TEXT_MANAGEMENT}`}
                                                        exact
                                                        activeClassName="active">
                                                        <FormattedMessage
                                                            id="dashboard.SmsSetting"
                                                            defaultMessage="SMS Setting" />
                                                    </NavLink>
                                                </li>
                                                : ''
                                            }
                                        </HasRole>

                                        <HasRole role={['primarynet', 'admin', 'manager', 'telephone', 'visiting']}>
                                            <li>
                                                <NavLink to={`/${routerName.BOARD}/${routerName.FREE_BOARD}`}
                                                    exact
                                                    activeClassName="active">
                                                    <FormattedMessage
                                                        id="BOARD.board"
                                                        defaultMessage="Free Board" />
                                                </NavLink>
                                            </li>
                                        </HasRole>

                                        <HasRole role={['admin']}>
                                            {localStorage.getItem("menu_4") === '1' ?
                                                <li>
                                                    <NavLink to={`/${routerName.DASHBOARD}/${routerName.DATA_SETTING}/${routerName.AFFILITED_COMPANY_MANAGEMENT}`}
                                                        exact
                                                        activeClassName="active">
                                                        <FormattedMessage
                                                            id="dashboard.DataSetting"
                                                            defaultMessage="Data Setting" />
                                                    </NavLink>
                                                </li>
                                                : ''
                                            }
                                        </HasRole>

                                    </ul>
                                </nav>
                            </div>
                            <div className="float_right">
                                <ul className="list_item_action">
                                    {process.env.NODE_ENV === 'development'
                                        ?
                                        <li>
                                            <select
                                                className="form-control form-control-sm"
                                                name="select"
                                                onChange={(event) => this.selectLanguageHandle(event)}
                                                value={appState.lang}
                                            >
                                                <option value='en' name='en'> English</option>
                                                <option value='ko' name='ko'> Korean</option>
                                            </select>
                                        </li>
                                        : ''}

                                    <li>
                                        <Link to="/#" className="zoom_now">
                                            <i className="fas fa-expand-arrows-alt" />
                                        </Link>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={`/${routerName.DOCUMENTATION}/${routerName.DOCUMENTATION_GETTING_STARTED}`}
                                            className="document-page"
                                            activeClassName="active">
                                            <FormattedMessage
                                                id="dashboard.Documentation"
                                                defaultMessage="Documentation" />
                                        </NavLink>
                                    </li>
                                    <li>
                                        <Link to="/#" className="question">
                                            <i className="fas fa-question" />
                                        </Link>
                                    </li>
                                    <li>
                                        <a href="#" onClick={this.toggleModalLogout} data-toggle="modal" className="sign">
                                            <span className="show">
                                                <FormattedMessage
                                                    id="dashboard.Logout"
                                                    defaultMessage="Logout" />
                                            </span>
                                            <span className="hide">
                                                <i className="fas fa-sign-out-alt" />
                                            </span>
                                        </a>
                                        <LogoutModal
                                            isOpen={this.state.openModalLogout}
                                            toggle={this.toggleModalLogout}
                                            onConfirm={this.userLogoutHandle}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </header>

                {this.props.children}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        appState: state.appState,
        auth: state.auth,
        companies: state.companies,
        lots: state.lots,
        sel_company_id: state.company_id,
        sel_lots_id: state.lots_id,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSetLocale: (lang) => dispatch(setLocaleAction(lang)),
        onUserLogout: () => dispatch(authLogoutAction()),
        changeSceneCompany: companyId => dispatch(changeSceneCompanyAction(companyId)),
        changeSceneLot: lotsId => dispatch(changeSceneLotAction(lotsId)),
    }
    // onFetchCompanies: (params={type:'list'}) => dispatch(fetchCompaniesAction(params)),
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
